/** Keeps Help "Go to" flows alive after pages strip `?helpGuide=` from the URL. */

const HELP_GUIDE_SESSION_KEY = "zeroHelpGuideBypass";

export function markHelpGuideActive(guide: string): void {
  if (!guide) return;
  sessionStorage.setItem(HELP_GUIDE_SESSION_KEY, guide);
}

export function clearHelpGuideActive(): void {
  sessionStorage.removeItem(HELP_GUIDE_SESSION_KEY);
}

export function isHelpGuideBypassActive(): boolean {
  return Boolean(sessionStorage.getItem(HELP_GUIDE_SESSION_KEY));
}

export function getActiveHelpGuide(): string | null {
  return sessionStorage.getItem(HELP_GUIDE_SESSION_KEY);
}
